import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { ProblemBox } from './components/ProblemBox';
import { Benefits } from './components/Benefits';
import { Products } from './components/Products';
import { Guarantee } from './components/Guarantee';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Problem data-id="element-3" />
      
      <Benefits data-id="element-4" />
      <Products data-id="element-5" />
      <Guarantee data-id="element-6" />
      <CTA data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}